import React, { useContext, useEffect } from "react";
import { useAuthContext } from "../../../../Context/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./step7";
import { useNavigate } from "react-router-dom";

const FormSteps = () => {
  const { step, prevStep } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = () => {
      prevStep();
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [prevStep]);

  switch (step) {
    case 1:
      return <Step1 />;
    case 2:
      return <Step2 />;
    case 3:
      return <Step3 />;
    case 4:
      return <Step4 />;
    case 5:
      return <Step5 />;
    case 6:
      return <Step6 />;
    case 7:
      return <Step7 />;
    default:
      navigate("/dashboard");
      return null;
  }
};

const MultiStepForm = () => {
  return (
    <GoogleOAuthProvider clientId="671164180097-m85hbtdcdv70dfo6i364llvv277dqpvi.apps.googleusercontent.com">
      <FormSteps />
    </GoogleOAuthProvider>
  );
};

export default MultiStepForm;
